/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Vs_Win5_DInputs */

const en_wc_vs_win5_d = /** @type {(inputs: Wc_Vs_Win5_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Native Rust on the GPU, with no Electron. Re-layout of a 188-page document takes about 1.4 ms per keystroke.`)
};

/**
* | output |
* | --- |
* | "Native Rust on the GPU, with no Electron. Re-layout of a 188-page document takes about 1.4 ms per keystroke." |
*
* @param {Wc_Vs_Win5_DInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_vs_win5_d = /** @type {((inputs?: Wc_Vs_Win5_DInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Vs_Win5_DInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_vs_win5_d(inputs)
});
export { wc_vs_win5_d as "wc.vs.win5.d" }